var exports = {
  "k": "x4c3adb35--89a292--container",
};

module.exports = exports;
